"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisputedAndFraudAnalysisDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.DisputedAndFraudAnalysisDescription = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.disputed_and_fraud_analysis_description.label',
    fallbackLabel: 'Do you perform analysis on which of your merchants represent a) elevated customer dispute and b) merchant fraud rates? Please describe your processes for merchants with elevated levels of those two risks (i.e. warnings, offboardings, etc).',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
